import React, { useEffect, useState } from "react";

/** Sidebar preview — SVG (no styled-components). */
export default function NeumorphicAnalogPreviewSvg() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, []);
  const cx = 150;
  const cy = 150;
  const markers = [];
  for (let i = 0; i < 12; i++) {
    const ang = -Math.PI / 2 + (i * Math.PI) / 6;
    const r = 132;
    const x = cx + r * Math.cos(ang);
    const y = cy + r * Math.sin(ang);
    const big = i % 3 === 0;
    markers.push(
      <circle
        key={`m-${i}`}
        cx={x}
        cy={y}
        r={big ? 4 : 3}
        fill="#e0e5ec"
        stroke="#c5cedd"
        strokeWidth="0.5"
      />
    );
  }

  const nums = [];
  for (let n = 1; n <= 12; n++) {
    const hIdx = n === 12 ? 0 : n;
    const angleRad = -Math.PI / 2 + (hIdx * Math.PI) / 6;
    const nr = 110;
    const tx = cx + nr * Math.cos(angleRad);
    const ty = cy + nr * Math.sin(angleRad);
    nums.push(
      <text
        key={`n-${n}`}
        x={tx}
        y={ty}
        textAnchor="middle"
        dominantBaseline="central"
        fill="#b8c1d1"
        fontSize="24"
        fontWeight="600"
        fontFamily="Helvetica Neue, Arial, sans-serif"
      >
        {n}
      </text>
    );
  }

  const now = new Date();
  const ms = now.getMilliseconds() / 1000;
  const sec = now.getSeconds() + ms;
  const min = now.getMinutes() + sec / 60;
  const hr = (now.getHours() % 12) + min / 60;
  const th = (-Math.PI / 2 + (hr / 12) * 2 * Math.PI) * (180 / Math.PI);
  const tm = (-Math.PI / 2 + (min / 60) * 2 * Math.PI) * (180 / Math.PI);
  const ts = (-Math.PI / 2 + (sec / 60) * 2 * Math.PI) * (180 / Math.PI);

  const outerStyle = {
    filter:
      "drop-shadow(10px 10px 16px rgba(163,177,198,0.55)) drop-shadow(-8px -8px 14px rgba(255,255,255,0.5))",
  };

  return (
    <svg
      viewBox="0 0 300 300"
      className="de-clock-neo-svg-preview"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="300" height="300" fill="#e0e5ec" />
      <circle cx={cx} cy={cy} r="148" fill="#e0e5ec" style={outerStyle} />
      <circle cx={cx} cy={cy} r="136" fill="#dde2e8" stroke="#eef2f7" strokeWidth="2" />
      {markers}
      {nums}
      <g transform={`translate(${cx},${cy}) rotate(${th})`}>
        <line x1="0" y1="0" x2="0" y2="-52" stroke="#4a5463" strokeWidth="8" strokeLinecap="round" />
      </g>
      <g transform={`translate(${cx},${cy}) rotate(${tm})`}>
        <line x1="0" y1="0" x2="0" y2="-82" stroke="#7a8a9e" strokeWidth="6" strokeLinecap="round" />
      </g>
      <g transform={`translate(${cx},${cy}) rotate(${ts})`}>
        <line x1="0" y1="0" x2="0" y2="-102" stroke="#e65e5e" strokeWidth="3" strokeLinecap="round" />
      </g>
      <circle cx={cx} cy={cy} r="10" fill="#e0e5ec" />
      <circle cx={cx} cy={cy} r="3" fill="#4a5463" />
    </svg>
  );
}
